module.exports = __webpack_public_path__ + "fc6_slide_mobile.jpg";